export {
    frMessages
};
export type {
    TranslationKey
};

/**
 * French interface translations.
 *
 * Lesson content remains data-driven and is intentionally not duplicated here.
 */
const frMessages = {
    "app.title": "Français avec Dino",

    "common.back": "Retour",
    "common.continue": "Continuer",
    "common.loading": "Chargement…",
    "common.soon": "Bientôt",
    "common.retry": "Recommencer",
    "common.finish": "Terminer",
    "common.next": "Suivant",
    "common.nextQuestion": "Question suivante",
    "common.words": "mots",
    "common.sections": "sections",
    "common.all": "Tout →",
    "common.excellent": "Excellent !",
    "common.good": "Bien !",
    "common.moreEffort": "Plus d'effort !",
    "common.morePractice": "Plus d'entraînement !",

    "error.notFound.title": "Contenu introuvable",
    "error.unavailable.title": "Contenu temporairement indisponible",
    "error.unavailable.body": "Le serveur pédagogique ne répond pas. Réessayez dans quelques instants.",

    "navbar.grammar": "Grammaire",
    "navbar.vocabulary": "Vocabulaire",
    "navbar.travel": "Voyage",
    "navbar.search": "Rechercher dans le site",
    "navbar.switchLanguage": "Passer en persan",
    "navbar.primaryNavigation": "Navigation principale",
    "navbar.menu": "Menu",
    "navbar.group.learning": "Apprendre",
    "navbar.group.discovery": "Découvrir",
    "navbar.group.services": "Services",
    "navbar.group.account": "Mon espace",
    "navbar.gamesExercises": "Jeux et exercices",
    "navbar.daily": "Ma session du jour",
    "navbar.placement": "Passer le test de niveau",
    "navbar.admin": "Atelier des contenus",
    "placement.title": "Test de niveau",
    "placement.return": "Revenir à ma page",
    "navbar.review": "Mes révisions",
    "navbar.music": "Musique",
    "navbar.journal": "Journal",
    "navbar.shop": "Boutique",
    "navbar.archive": "Archive",
    "navbar.profile": "Profil",
    "navbar.soon": "Bientôt",
    "navbar.unavailable": "Bientôt disponible",

    "footer.tagline": "Le français, étape par étape.",
    "footer.navigationLabel": "Informations sur Dino",
    "footer.socialLabel": "Retrouvez Dino sur les réseaux",
    "footer.about": "À propos",
    "footer.contact": "Contact",
    "footer.workWithUs": "Travailler avec nous",
    "footer.dinoAssistant": "Dino et l’IA locale",

    "institutional.eyebrow": "Français avec Dino",
    "institutional.about.title": "À propos",
    "institutional.about.introduction": "Dino aide les apprenants à pratiquer le français avec des parcours courts, progressifs et concrets.",
    "institutional.about.missionTitle": "Notre mission",
    "institutional.about.missionBody": "Rendre l'apprentissage du français plus clair grâce à des leçons structurées, du vocabulaire utile et une pratique régulière.",
    "institutional.about.methodTitle": "Notre méthode",
    "institutional.about.methodBody": "Les contenus suivent les niveaux du CECRL et relient explications, exemples, exercices et situations de la vie réelle.",
    "institutional.about.audienceTitle": "Pour qui ?",
    "institutional.about.audienceBody": "L'expérience est conçue pour tous les apprenants et offre un accompagnement bilingue particulièrement utile aux persanophones.",
    "institutional.about.privacyTitle": "Une progression qui reste sur cet appareil",
    "institutional.about.privacyBody": "Le niveau, la progression et les révisions restent enregistrés dans ce navigateur. Si vous choisissez de créer un compte, seuls votre email et votre profil privé sont synchronisés et protégés par des règles d'accès individuelles.",
    "institutional.contact.title": "Contact",
    "institutional.contact.introduction": "Une question, un contenu à corriger ou un problème technique ? Utilisez le canal public du projet pour que la demande soit suivie.",
    "institutional.contact.beforeTitle": "Pour nous aider à répondre efficacement",
    "institutional.contact.itemContent": "Pour une correction pédagogique, indiquez la leçon, le niveau et le passage concerné.",
    "institutional.contact.itemBug": "Pour un bug, précisez l'appareil, le navigateur et les étapes qui reproduisent le problème.",
    "institutional.contact.itemAccessibility": "Pour un problème d'accessibilité, décrivez l'action bloquée et la technologie d'assistance utilisée.",
    "institutional.contact.action": "Ouvrir une demande",
    "institutional.contact.actionMeta": "Créez une issue dans le dépôt public Dino afin de conserver le contexte et le suivi de la réponse.",
    "institutional.contact.publicNotice": "Les demandes GitHub sont publiques : n'y publiez aucune information personnelle ou confidentielle.",
    "institutional.contact.socialTitle": "Nous suivre",
    "institutional.work.title": "Travailler avec nous",
    "institutional.work.introduction": "Dino grandit avec des contributions ciblées qui améliorent directement l'expérience d'apprentissage.",
    "institutional.work.contentTitle": "Pédagogie et contenus",
    "institutional.work.contentBody": "Relire une leçon, améliorer une traduction ou proposer un exercice français-persan conforme au niveau visé.",
    "institutional.work.productTitle": "Produit et accessibilité",
    "institutional.work.productBody": "Clarifier un parcours, tester l'expérience mobile ou signaler un obstacle pour les utilisateurs de technologies d'assistance.",
    "institutional.work.technicalTitle": "Développement",
    "institutional.work.technicalBody": "Corriger un bug, renforcer les tests ou faire évoluer l'architecture en gardant les modules et les données séparés.",
    "institutional.work.action": "Consulter le guide de contribution",
    "institutional.work.actionMeta": "Le dépôt public décrit l'installation locale, les contrôles qualité et les principes à respecter avant une proposition.",

    "institutional.dino.eyebrow": "Transparence produit",
    "institutional.dino.title": "Comment fonctionne Dino ?",
    "institutional.dino.introduction": "Dino est un compagnon contextuel local-first : il observe uniquement la page en cours, choisit quelques aides pertinentes et garde les fonctions encore expérimentales clairement séparées.",
    "institutional.dino.tryAction": "Essayer Dino",
    "institutional.dino.contextTitle": "Un contexte limité",
    "institutional.dino.contextBody": "Dino connaît le type de page, l’identifiant public de la leçon et la carte que vous lui montrez. Les réponses, jetons et données sensibles sont exclus de ce contexte.",
    "institutional.dino.localTitle": "Une décision locale",
    "institutional.dino.localBody": "Le navigateur classe les aides avec des règles locales et n’en affiche jamais plus de trois. Aucun contexte pédagogique n’est envoyé à notre serveur pour cette sélection.",
    "institutional.dino.voiceTitle": "Une lecture adaptée",
    "institutional.dino.voiceBody": "La langue du texte est détectée automatiquement, le mot en cours est surligné et Dino privilégie la voix la plus naturelle disponible. Le fonctionnement hors ligne dépend de l’appareil et du navigateur.",
    "institutional.dino.avatarLabel": "Dino réfléchit",
    "institutional.dino.nowEyebrow": "Fonctionnement actuel",
    "institutional.dino.nowTitle": "Utile maintenant, extensible ensuite",
    "institutional.dino.nowBody": "Aujourd’hui, Dino lit une carte, explique une section de grammaire depuis ses extraits canoniques et propose un indice stratégique pendant un exercice. Ce contrat pourra accueillir un modèle d’IA local sans reconstruire l’interface.",
    "institutional.dino.availableTitle": "Disponible",
    "institutional.dino.availableBody": "Lecture ciblée, mot ou expression au clic, meilleure voix disponible, explication locale bornée et indice guidé sans réponse attendue.",
    "institutional.dino.plannedTitle": "Prévu, mais inactif",
    "institutional.dino.plannedBody": "Reformulations génératives, explication des erreurs, conversation, microphone et caméra restent signalés « À venir » tant qu’un moteur local fiable et les autorisations nécessaires ne sont pas branchés.",
    "institutional.dino.privacyTitle": "Ce que local-first signifie réellement",
    "institutional.dino.privacyBody": "La sélection des aides et le contexte Dino restent dans l’application. La synthèse vocale est fournie par le navigateur et peut dépendre des services du système. Microphone et caméra ne démarrent jamais sans action et autorisation explicites.",

    "auth.eyebrow": "Mon espace",
    "auth.title": "Connexion par email",
    "auth.introduction": "Recevez un lien de connexion sécurisé par email. Aucun mot de passe à créer ou à mémoriser.",
    "auth.emailLabel": "Adresse email",
    "auth.emailPlaceholder": "vous@exemple.fr",
    "auth.requestCode": "Recevoir mon lien",
    "auth.codeTitle": "Consultez votre messagerie",
    "auth.codeSent": "Ouvrez le lien sécurisé envoyé à {email}. Si l’email affiche un code à 6 chiffres, vous pouvez aussi le saisir ici.",
    "auth.codeLabel": "Code à 6 chiffres (si affiché)",
    "auth.verifyCode": "Valider le code",
    "auth.changeEmail": "Changer d’email",
    "auth.resend": "Renvoyer l’email",
    "auth.resendIn": "Renvoyer dans {seconds}s",
    "auth.invalidEmail": "Saisissez une adresse email valide.",
    "auth.invalidCode": "Le code doit contenir exactement 6 chiffres.",
    "auth.genericError": "Impossible de valider la connexion. Vérifiez le code ou réessayez dans quelques instants.",
    "auth.unavailableTitle": "Connexion temporairement indisponible",
    "auth.unavailableBody": "Le site pédagogique reste accessible. Le service de compte n’est pas configuré sur cet environnement.",
    "auth.privacy": "Votre adresse sert uniquement à sécuriser votre compte Dino. Ne transmettez jamais votre lien ou votre code de connexion.",

    "profile.eyebrow": "Mon espace",
    "profile.title": "Mon profil",
    "profile.createIntroduction": "Créez l’identité qui vous accompagnera dans Dino.",
    "profile.editIntroduction": "Modifiez votre nom, votre avatar et la manière dont Dino vous présente.",
    "profile.email": "Compte connecté",
    "profile.displayName": "Nom affiché",
    "profile.displayNameHint": "Entre 2 et 40 caractères. Votre email n’est jamais affiché publiquement.",
    "profile.avatar": "Avatar",
    "profile.avatar.green": "Dino vert",
    "profile.avatar.blue": "Dino bleu",
    "profile.avatar.coral": "Dino corail",
    "profile.saurusSuffix": "Ajouter « Saurus » à mon nom",
    "profile.saurusSuffixHint": "Exemple : Mina devient Mina Saurus. Vous pouvez désactiver ce suffixe à tout moment.",
    "profile.saurusRequiredTitle": "Ton Saurus t’attend",
    "profile.saurusRequiredBody": "Réponds à trois questions, découvre la recommandation de Dino puis choisis ton compagnon.",
    "profile.saurusRequiredAction": "Découvrir mon Saurus →",
    "profile.preview": "Aperçu",
    "profile.previewPlaceholder": "Votre nom Saurus",
    "profile.create": "Créer mon profil",
    "profile.save": "Enregistrer",
    "profile.saved": "Profil enregistré.",
    "profile.invalid": "Le nom doit contenir entre 2 et 40 caractères.",
    "profile.saveError": "Impossible d’enregistrer le profil pour le moment.",
    "profile.unavailableTitle": "Profil temporairement indisponible",
    "profile.unavailableBody": "Le service de compte est inaccessible, mais les leçons restent disponibles.",
    "profile.signOut": "Se déconnecter",
    "profile.signOutError": "Impossible de se déconnecter pour le moment.",
    "profile.credits": "Mes crédits",
    "profile.creditsUnavailable": "Crédits indisponibles",
    "profile.openShop": "Ouvrir la boutique",
    "profile.rewardsTitle": "Récompenses obtenues",
    "profile.rewardsDescription": "Vos dernières activités récompensées.",
    "profile.rewardsEmpty": "Terminez une leçon Voyage ou gagnez un jeu pour obtenir vos premiers crédits.",
    "profile.rewardsUnavailable": "Historique temporairement indisponible.",
    "profile.rewardFallback": "Activité d’apprentissage",
    "profile.rewardHangman": "Pendu · niveau {level}",
    "profile.rewardWordSearch": "Grille de lettres · niveau {level}",
    "profile.rewardCrossword": "Mots croisés · niveau {level}",
    "profile.rewardCredits": "+{count} crédits",
    "profile.progressSyncTitle": "Progression multi-appareils",
    "profile.progressSyncReady": "Vos leçons de Grammaire et de Voyage sont synchronisées sur ce compte.",
    "profile.progressSyncing": "Synchronisation de votre progression en cours…",
    "profile.progressSyncError": "La progression reste enregistrée sur cet appareil. Le prochain démarrage ou apprentissage relancera la synchronisation.",
    "profile.learningProgressTitle": "Ma progression",
    "profile.learningProgressDescription": "Un aperçu de vos parcours terminés et de vos récompenses de jeu.",
    "profile.learningProgressGrammar": "Grammaire",
    "profile.learningProgressTravel": "Voyage",
    "profile.learningProgressGames": "Jeux",
    "profile.learningProgressLessons": "{completed} / {total} leçons terminées",
    "profile.learningProgressRewards": "{completed} / {total} récompenses obtenues",
    "profile.learningProgressUnavailable": "Le résumé de progression est temporairement indisponible.",
    "profile.exerciseHistoryTitle": "Mes exercices",
    "profile.exerciseHistoryDescription": "Vos derniers scores, conservés sur cet appareil et synchronisés avec votre compte.",
    "profile.exerciseHistoryEmpty": "Terminez un exercice de Grammaire, Voyage ou Vocabulaire pour voir votre historique.",
    "profile.exerciseAttempts": "Tentatives",
    "profile.exerciseAverage": "Moyenne",
    "profile.exerciseBest": "Meilleur",
    "profile.exerciseGrammar": "Grammaire · {id}",
    "profile.exerciseTravel": "Voyage · {id}",
    "profile.exerciseVocabulary": "Vocabulaire · niveau {level}",
    "profile.exerciseScore": "{correct}/{total} · {percentage}%",
    "profile.exerciseSyncError": "Ces scores restent enregistrés sur cet appareil. La synchronisation reprendra automatiquement.",
    "profile.dailyPracticeTitle": "Mon rythme",
    "profile.dailyGoalReached": "Objectif du jour atteint, bravo !",
    "profile.dailyGoalRemaining": "Encore {count} exercice(s) pour atteindre l’objectif du jour.",
    "profile.dailyGoalStart": "Commencez un exercice pour lancer votre journée.",
    "profile.dailyStreak": "🔥 {count} jour(s)",
    "profile.dailyGoalProgress": "Objectif quotidien",
    "profile.dailyDayLabel": "{day} : {count} exercice(s)",
    "profile.dailyPracticeAction": "Faire ma session →",

    "saurus.eyebrow": "Mon aventure",
    "saurus.title": "Quel Saurus es-tu ?",
    "saurus.introduction": "Trois questions pour découvrir ton compagnon d’apprentissage. Dino te fait une recommandation, puis le choix final t’appartient.",
    "saurus.quiz.progress": "Question {current} sur {total}",
    "saurus.quiz.progressLabel": "Progression du test Saurus",
    "saurus.quiz.question.newLesson": "Quand tu découvres une nouvelle leçon, qu’est-ce qui te ressemble le plus ?",
    "saurus.quiz.question.challenge": "Face à un exercice difficile, comment préfères-tu avancer ?",
    "saurus.quiz.question.session": "Quelle session d’apprentissage te donne le plus envie ?",
    "saurus.quiz.answer.explore": "Explorer rapidement et essayer plusieurs pistes",
    "saurus.quiz.answer.persist": "Répéter calmement jusqu’à maîtriser",
    "saurus.quiz.answer.understand": "Comprendre le pourquoi avant de continuer",
    "saurus.quiz.answer.try": "Me lancer tout de suite et ajuster ensuite",
    "saurus.quiz.answer.steps": "Progresser étape par étape sans abandonner",
    "saurus.quiz.answer.connect": "Observer et relier les idées entre elles",
    "saurus.quiz.answer.varied": "Courte, vive et pleine de découvertes",
    "saurus.quiz.answer.regular": "Structurée, régulière et rassurante",
    "saurus.quiz.answer.deep": "Curieuse, approfondie et riche en explications",
    "saurus.velociraptor.name": "Vélociraptor explorateur",
    "saurus.velociraptor.trait": "Vif et audacieux, il apprend en essayant et en explorant.",
    "saurus.triceratops.name": "Tricératops persévérant",
    "saurus.triceratops.trait": "Solide et régulier, il avance étape par étape sans renoncer.",
    "saurus.brachiosaurus.name": "Brachiosaure curieux",
    "saurus.brachiosaurus.trait": "Attentif et curieux, il aime comprendre et relier les idées.",
    "saurus.choice.recommendation": "La recommandation de Dino",
    "saurus.choice.title": "Choisis ton compagnon",
    "saurus.choice.hint": "Tu peux garder la recommandation ou choisir le Saurus qui te correspond le mieux. L’espèce restera ensuite stable.",
    "saurus.choice.recommended": "Recommandé",
    "saurus.choice.error": "L’attribution n’a pas pu être confirmée. Ton choix est conservé sur cet écran : réessaie dans un instant.",
    "saurus.choice.restart": "Refaire le test",
    "saurus.choice.confirm": "Confirmer mon Saurus",
    "saurus.assigned.title": "Ton Saurus est prêt !",
    "saurus.assigned.introduction": "Ton espèce est désormais liée à ton profil. Elle restera la même et évoluera avec tes activités.",
    "saurus.assigned.profile": "Voir mon profil",
    "saurus.assigned.home": "Entrer dans Dino →",
    "saurus.identity.label": "Identité Saurus",
    "saurus.identity.title": "Mon Saurus",
    "saurus.identity.visible": "Visible sur ton profil",
    "saurus.phase.label": "Phase · {phase}",
    "saurus.phase.hatchling": "Éclosion",
    "saurus.phase.explorer": "Exploration",
    "saurus.phase.guide": "Guide",
    "saurus.phase.progress": "Évolution du Saurus",
    "saurus.phase.remaining": "Encore {count} activité(s)",
    "saurus.phase.complete": "Phase Guide atteinte : ton Saurus a terminé son évolution actuelle.",
    "saurus.error.title": "Saurus temporairement indisponible",
    "saurus.error.body": "Ton profil reste intact. Reviens dans quelques instants pour reprendre le test.",

    "archive.eyebrow": "Mon espace",
    "archive.title": "Mon archive",
    "archive.introduction": "Retrouvez les leçons terminées et vos résultats d’exercices, avec un lien direct pour les rouvrir.",
    "archive.completedTitle": "Leçons terminées",
    "archive.completedDescription": "Votre bibliothèque locale suit votre compte lorsqu’il est connecté.",
    "archive.completedCount": "{count} leçon(s)",
    "archive.grammar": "Grammaire",
    "archive.travel": "Voyage",
    "archive.completedAt": "Terminée le {date}",
    "archive.emptyTitle": "Votre archive est prête à grandir",
    "archive.emptyDescription": "Terminez une leçon de Grammaire ou de Voyage pour la retrouver ici.",
    "archive.startDaily": "Commencer ma session →",
    "archive.exercisesTitle": "Historique des exercices",
    "archive.exercisesDescription": "Vos derniers résultats de Grammaire, Voyage et Vocabulaire.",
    "archive.loadErrorTitle": "Impossible de charger les titres de l’archive",
    "archive.loadErrorDescription": "Votre progression reste intacte sur cet appareil. Réessayez pour relier les leçons.",

    "rewards.available": "🎁 Terminez cette leçon : +{count} crédits",
    "rewards.gameAvailable": "🏆 Gagnez une partie au niveau {level} : +{count} crédits",
    "rewards.gameSignIn": "🏆 Partie gagnée : connectez-vous pour recevoir {count} crédits",
    "rewards.claiming": "🎁 Attribution de vos crédits…",
    "rewards.awardedOne": "🎉 1 crédit gagné",
    "rewards.awarded": "🎉 {count} crédits gagnés",
    "rewards.signIn": "🎁 Leçon terminée : connectez-vous pour recevoir {count} crédits",
    "rewards.claimError": "La récompense n’a pas pu être confirmée.",

    "shop.eyebrow": "Services",
    "shop.title": "Boutique",
    "shop.introduction": "Débloquez de nouvelles leçons avec les crédits associés à votre profil. Un achat reste disponible dans votre collection.",
    "shop.balance": "Mon solde",
    "shop.balanceUnavailable": "Solde indisponible",
    "shop.credit": "{count} crédit",
    "shop.credits": "{count} crédits",
    "shop.catalogPrice": "Boutique · {price} crédits",
    "shop.loading": "Chargement de la boutique…",
    "shop.catalogTitle": "Leçons disponibles",
    "shop.catalogDescription": "Choisissez une leçon, vérifiez son niveau et son prix avant de l’ajouter à votre collection.",
    "shop.lesson": "Leçon",
    "shop.level": "Niveau {level}",
    "shop.owned": "Possédée",
    "shop.openLesson": "Ouvrir la leçon",
    "shop.buyPrice": "Acheter · {price}",
    "shop.buying": "Achat en cours…",
    "shop.insufficientCredits": "Crédits insuffisants",
    "shop.signInTitle": "Connectez-vous pour utiliser vos crédits",
    "shop.signInBody": "Vous pouvez parcourir les leçons maintenant. La connexion protège votre solde et vos achats.",
    "shop.signIn": "Se connecter",
    "shop.signInToBuy": "Se connecter pour acheter",
    "shop.purchaseSuccess": "« {title} » a été ajoutée à votre collection.",
    "shop.purchaseError": "Achat non confirmé. Votre solde et vos leçons sont actualisés avant une nouvelle tentative.",
    "shop.unavailableTitle": "Boutique temporairement indisponible",
    "shop.unavailableBody": "Le service d’achat n’est pas configuré sur cet environnement. Les leçons déjà accessibles restent disponibles.",
    "shop.errorTitle": "Impossible de charger la boutique",
    "shop.errorBody": "Votre solde n’a pas été modifié. Revenez dans quelques instants.",
    "shop.emptyTitle": "Aucune leçon en vente pour le moment",
    "shop.emptyBody": "De nouvelles leçons apparaîtront ici dès qu’elles seront disponibles.",
    "shop.lockedTitle": "Cette leçon est à débloquer",
    "shop.lockedBody": "Retrouvez cette leçon dans la boutique et ajoutez-la à votre collection avec vos crédits.",
    "shop.lockedSignIn": "Se connecter pour la débloquer",

    "onboarding.chooseLanguage": "Choisissez la langue",
    "onboarding.french": "Français",
    "onboarding.persian": "فارسی",
    "onboarding.choosePath": "Choisissez votre parcours",
    "onboarding.general": "Français général",
    "onboarding.travel": "Français Voyage",
    "onboarding.levelQuestion": "Souhaitez-vous passer un test de niveau ?",
    "onboarding.startTest": "Passer le test",
    "onboarding.later": "Plus tard",
    "onboarding.dontKnow": "Je ne sais pas",
    "onboarding.finalResult": "Résultat du test",
    "onboarding.yourLevel": "Votre niveau estimé",
    "onboarding.canModify": "Vous pourrez toujours le modifier plus tard.",
    "onboarding.acceptLevel": "Accepter ce niveau",
    "onboarding.changeLevel": "Changer de niveau",
    "onboarding.chooseYourLevel": "Choisissez votre niveau",

    "home.greeting": "Bonjour, continuez !",
    "home.currentLevel": "Votre niveau actuel",
    "home.dailySessionOpen": "Ouvrir ma session du jour",
    "home.dailySessionProgress": "{completed}/{total} aujourd’hui",
    "home.newsAdvice": "📰 Actualités & conseils",

    "exercise.defaultTitle": "Exercice",
    "exercise.unsupportedQuestion": "Ce type de question n'est pas encore pris en charge dans l'interface.",
    "exercise.correct": "Bravo!",
    "exercise.incorrect": "Incorrect!",
    "exercise.returnLesson": "Retour à la leçon",

    "grammar.level.A1": "Débutant",
    "grammar.level.A2": "Élémentaire",
    "grammar.level.B1": "Intermédiaire",
    "grammar.level.B2": "Avancé",
    "grammar.level.C1": "Autonome",
    "grammar.level.C2": "Maîtrise",
    "grammar.chooseLevel": "Choisissez votre niveau de grammaire.",
    "grammar.levelMeta": "Voir les leçons",
    "grammar.recommended": "Recommandé",
    "grammar.allLessons": "Toutes les leçons",
    "grammar.exercises": "Exercices",
    "grammar.lessonNotFound": "Impossible de trouver cette leçon.",
    "grammar.sectionNotFound": "Impossible de trouver cette section.",
    "grammar.type.lesson": "Leçon",
    "grammar.type.exercise": "Exercice",
    "grammar.type.quiz": "Quiz",
    "grammar.completedSuffix": " · Terminé",
    "grammar.progress": "Progression",
    "grammar.examples": "Exemples",
    "grammar.status.completed": "Terminé",
    "grammar.status.inProgress": "En cours",
    "grammar.status.notStarted": "Non commencé",

    "travel.catalogTitle": "Voyage ({count} leçons)",
    "travel.noLessons": "Aucune leçon trouvée.",
    "travel.lessonNotFound": "Leçon introuvable.",
    "travel.sectionsCount": "{count} sections",
    "travel.type.vocab": "Vocabulaire",
    "travel.type.tips": "Conseils",
    "travel.type.lesson": "Leçon",
    "travel.type.exercise": "Exercice",
    "travel.type.unknown": "Section",
    "travel.exerciseOpensSeparately": "Cet exercice s’ouvre dans l’écran d’exercice.",
    "travel.unsupportedContent": "Type de contenu non supporté : {type}",
    "travel.tipFallback": "Conseil {number}",

    "poll.weekly": "Sondage de la semaine",
    "poll.subtitle": "Votre avis compte pour nous!",
    "poll.totalVotes": "Total des votes: {count}",
    "poll.changeVote": "Changer mon vote",

    "news.weekly": "Actualité",
    "news.journalTitle": "Journal",
    "news.journalSubtitle": "Actualités et culture française adaptées à votre niveau.",
    "news.journalEmpty": "Aucun article n’est disponible pour le moment.",
    "news.readMore": "Lire la suite ←",
    "news.fullText": "Texte complet",
    "news.simpleText": "Texte simple",
    "news.simplifiedVersion": "Version simplifiée",
    "news.keyVocabulary": "Vocabulaire clé",
    "news.viewVocabularyPack": "Voir le pack de vocabulaire",
    "news.grammarPoints": "Points de grammaire",
    "news.viewGrammarLesson": "Voir la leçon de grammaire",
    "news.grammarLevel": "⚠️ Ce point est pour le niveau {level}.",
    "news.advancedGrammarHidden": "💡 Les points de grammaire de ce texte sont trop avancés pour votre niveau et ont été masqués.",
    "news.sources": "Sources",
    "news.notFound": "Cet article est introuvable.",

    "search.title": "Rechercher",
    "search.close": "Fermer la recherche",
    "search.placeholder": "Mot ou expression...",
    "search.minCharacters": "Tapez au moins 2 caractères...",
    "search.loading": "Recherche...",
    "search.noResults": "Aucun résultat.",
    "search.error": "Erreur de recherche",
    "search.vocabulary": "Vocabulaire",
    "search.grammar": "Grammaire",
    "search.news": "Actualités",

    "practice.eyebrow": "S’entraîner",
    "practice.title": "Jeux et exercices",
    "practice.introduction": "Choisissez un jeu, un niveau et un thème. Chaque partie possède une adresse que vous pouvez conserver ou partager.",
    "practice.gamesTitle": "Jeux de vocabulaire",
    "practice.gamesDescription": "Trois façons ludiques de mémoriser les mots en français.",
    "practice.chooseLevel": "Choisir un niveau",
    "practice.playLevel": "Jouer au niveau {level}",
    "practice.chooseTheme": "Choisissez le thème de votre partie.",
    "practice.chooseAnotherTheme": "Choisir un autre thème",
    "practice.noThemes": "Aucun thème n’est disponible pour ce niveau.",
    "practice.invalidRoute": "Ce jeu ou ce niveau n’existe pas.",
    "practice.exercisesTitle": "Parcours d’exercices",
    "practice.exercisesDescription": "Retrouvez les activités intégrées aux leçons et aux packs.",
    "practice.grammarDescription": "Comprendre une règle puis la mettre en pratique.",
    "practice.vocabularyDescription": "Réviser avec des cartes, histoires et quiz.",
    "practice.travelDescription": "S’exercer dans des situations de voyage concrètes.",

    "daily.eyebrow": "Session quotidienne",
    "daily.title": "Ma session du jour",
    "daily.introduction": "Trois actions personnalisées pour avancer sans chercher quoi travailler.",
    "daily.cardDescription": "Retrouvez trois priorités adaptées à vos résultats et à votre niveau.",
    "daily.level": "Niveau {level}",
    "daily.tasksTitle": "Vos trois étapes",
    "daily.tasksDescription": "Les difficultés récentes passent en premier, puis Dino complète avec votre niveau.",
    "daily.reason.score": "Dernier score : {percentage}%",
    "daily.reason.mistake": "{count} réponse(s) à retravailler",
    "daily.reason.weakWord": "{count} mot(s) difficile(s) à revoir",
    "daily.reason.discovery": "Suggestion adaptée à votre niveau",
    "daily.openTask": "Commencer →",
    "daily.loadErrorTitle": "Impossible de préparer la session",
    "daily.loadErrorDescription": "Votre progression reste intacte. Réessayez pour recharger les activités disponibles.",
    "daily.emptyTitle": "Aucune activité disponible aujourd’hui",
    "daily.emptyDescription": "Les prochaines activités apparaîtront ici dès qu’un contenu compatible sera disponible.",
    "daily.completeTitle": "Objectif du jour atteint !",
    "daily.completeDescription": "Vos trois exercices sont terminés. Votre série et vos résultats sont déjà à jour.",
    "daily.openReview": "Voir mes révisions →",

    "review.eyebrow": "Entraînement personnalisé",
    "review.title": "Mes révisions",
    "review.cardDescription": "Reprenez vos erreurs et les mots que vous avez signalés comme difficiles.",
    "review.introduction": "Dino transforme vos difficultés enregistrées en prochaines actions concrètes.",
    "review.localNotice": "Sans compte connecté, vos erreurs, mots faibles et résultats restent enregistrés sur cet appareil.",
    "review.syncReady": "Vos révisions et résultats sont synchronisés sur ce compte et disponibles sur vos autres appareils.",
    "review.syncing": "Synchronisation de vos révisions en cours…",
    "review.syncError": "Vos révisions restent disponibles sur cet appareil. Le prochain démarrage ou apprentissage relancera la synchronisation.",
    "review.mistakeCount": "{count} erreur(s)",
    "review.wordCount": "{count} mot(s) faible(s)",
    "review.scoreCount": "{count} score(s) à revoir",
    "review.emptyTitle": "Rien à réviser pour le moment",
    "review.emptyDescription": "Continuez les leçons et marquez les mots difficiles : ils apparaîtront ici automatiquement.",
    "review.openPractice": "Choisir une activité",
    "review.mistakesTitle": "Leçons à reprendre",
    "review.mistakesDescription": "Les leçons sont classées selon votre erreur la plus récente.",
    "review.lessonMistakes": "{count} réponse(s) à retravailler",
    "review.retryLesson": "Reprendre la leçon",
    "review.markReviewed": "Marquer comme révisé",
    "review.noMistakes": "Aucune réponse incorrecte enregistrée.",
    "review.weakWordsTitle": "Mots faibles",
    "review.weakWordsDescription": "Relancez directement une session de flashcards ciblée.",
    "review.reviewWords": "Réviser {count} mot(s) →",
    "review.noWeakWords": "Aucun mot faible enregistré.",
    "review.scoresTitle": "Exercices à retravailler",
    "review.scoresDescription": "Le dernier essai de chaque exercice sous 80 % apparaît ici, du score le plus faible au plus élevé.",
    "review.scoreAttempt": "Dernier essai le {date}",
    "review.scoreResult": "{correct}/{total} · {percentage}%",
    "review.scoreProgress": "Résultat pour {title}",
    "review.retryExercise": "Reprendre l’exercice →",
    "review.noLowScores": "Aucun exercice sous l’objectif de 80 %.",

    "vocab.title": "📖 Vocabulaire",
    "vocab.chooseLevel": "Choisissez votre niveau",
    "vocab.levelMeta": "Flashcards & histoires",
    "vocab.chooseCategory": "Choisissez une catégorie",
    "vocab.packSoon": "Bientôt disponible.",
    "vocab.flashcards": "Flashcards",
    "vocab.simpleStory": "Histoire simple",
    "vocab.simpleStoryMeta": "Texte court à trous",
    "vocab.literaryStory": "Histoire littéraire",
    "vocab.literaryStoryMeta": "Texte plus long à trous",
    "vocab.quiz": "Quiz",
    "vocab.quizMeta": "Quiz rapide",
    "vocab.weakWords": "Mots faibles",
    "vocab.noWeakWords": "Aucun mot à réviser !",
    "vocab.cardHint": "👆 Touchez pour voir le sens et l'exemple",
    "vocab.unknown": "Je ne sais pas",
    "vocab.known": "Je sais",
    "vocab.weakWordsNote": "Les mots inconnus seront révisés à la fin et gardés pour la prochaine fois.",
    "vocab.unknownCount": "{count} mot(s) non connu(s)",
    "vocab.reviewNow": "C'est l'heure de réviser !",
    "vocab.review": "Réviser",
    "vocab.toggleTranslation": "Traduction",
    "vocab.keywords": "Mots-clés",
    "vocab.comprehension": "Compréhension",
    "vocab.fillBlanks": "Remplis les trous avec le bon mot :",
    "vocab.checkAnswers": "Vérifier les réponses",
    "vocab.storyTranslation": "Traduction de l'histoire",
    "vocab.exerciseSoon": "Bientôt",
    "vocab.game.hangman": "Pendu",
    "vocab.game.hangmanMeta": "Devinez le mot lettre par lettre",
    "vocab.game.hangmanInstructions": "Choisissez les lettres avant d'épuiser vos sept essais.",
    "vocab.game.wordSearch": "Grille de lettres",
    "vocab.game.wordSearchMeta": "Retrouvez les mots du thème",
    "vocab.game.wordSearchInstructions": "Touchez la première puis la dernière lettre d'un mot, dans les deux sens.",
    "vocab.game.crossword": "Mots croisés",
    "vocab.game.crosswordMeta": "Complétez la grille avec les traductions",
    "vocab.game.crosswordInstructions": "Utilisez les indices en persan pour compléter les mots français.",
    "vocab.game.newRound": "Nouvelle partie",
    "vocab.game.clue": "Indice",
    "vocab.game.remaining": "{count} erreur(s) encore possible(s)",
    "vocab.game.wrongLetters": "Lettres incorrectes",
    "vocab.game.won": "Bravo ! Le mot était « {word} ».",
    "vocab.game.lost": "Partie terminée. Le mot était « {word} ».",
    "vocab.game.wordsToFind": "Mots à trouver",
    "vocab.game.foundCount": "{found}/{total} mot(s) trouvé(s)",
    "vocab.game.selectEnd": "Choisissez maintenant la dernière lettre.",
    "vocab.game.wordFound": "« {word} » trouvé !",
    "vocab.game.wordSearchMiss": "Cette ligne ne correspond à aucun mot restant.",
    "vocab.game.wordSearchCompleted": "Grille terminée, bravo !",
    "vocab.game.across": "Horizontal",
    "vocab.game.down": "Vertical",
    "vocab.game.check": "Vérifier la grille",
    "vocab.game.crosswordCell": "Ligne {row}, colonne {column}",
    "vocab.game.crosswordCompleted": "Mots croisés terminés, bravo !",
    "vocab.game.crosswordRetry": "Certaines lettres sont incorrectes ou manquantes.",
    "vocab.game.unavailable": "Ce pack ne contient pas encore assez de mots compatibles pour ce jeu."
} as const;

type TranslationKey = keyof typeof frMessages;
